import { render, staticRenderFns } from "./CaseFrom.vue?vue&type=template&id=55b4f273&scoped=true"
import script from "./CaseFrom.vue?vue&type=script&lang=js"
export * from "./CaseFrom.vue?vue&type=script&lang=js"
import style0 from "./CaseFrom.vue?vue&type=style&index=0&id=55b4f273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4f273",
  null
  
)

export default component.exports